import type { AccountUser, SwitchCity } from '@travelata-libs/travelata-frontend';
import { reactive } from 'vue';
import account from '@/js/desktop/components/account';
import eventBus from '@ve/services/eventBus';
import { getPanelList, getCurrentCity } from '@entities/region-city';

declare let window: any;

export function createHeaderBindings() {
    const cities = getPanelList();
    const currentCity = getCurrentCity(cities);
    const auth = reactive<{ user: AccountUser | null }>({ user: null });

    const onAuthorize = (user: AccountUser) => {
        auth.user = user;
    };
    eventBus.$on('authorize', onAuthorize);

    return {
        auth,
        props: { cities, currentCity, accountUrl: window.appConfig.accountUrl },
        listeners: {
            login: () => account.topMenuBar.openAuthForm(),
            logout: () => {
                auth.user = null;
                account.topMenuBar.logout();
            },
            buy: () => {
                $('.openGeneralLeadForm')?.click();
            },
            ['change:city']: (city: SwitchCity) => {
                cities.find((panelCity) => panelCity.id === city.id)?.el?.click();
            },
        },
        destroy: () => eventBus.$off('authorize', onAuthorize),
    };
}
